const color = {
  basecolor: '#8C6239',
  overview: '#82C3CA',
  whatHappens: '#FFF028',
  love: '#FFBEE0',
  marriage: '#FF9595',
  family: '#FFB44D',
  work: '#9BD3FF',
  money: '#E4B51F',
  relationship: '#BEEB5E',
  flowOfFortune: '#CCB7FF',
  adviceForFirstHalf: '#92ABFF',
  luckyDayCalendar: '#85D97F',
  affinity: '#F5B09D'
}

const set = {
  flowOfFortuneSet: ['overview', 'whatHappens', 'flowOfFortune'],
  loveSet: ['love', 'marriage', 'affinity'],
  relationshipSet: ['work', 'money', 'relationship'],
  allSet: [
    'overview',
    'whatHappens',
    'love',
    'marriage',
    'family',
    'work',
    'money',
    'relationship',
    'flowOfFortune',
    'adviceForFirstHalf',
    'luckyDayCalendar',
    'affinity'
  ]
}

const itemIds = {
  id273: 'overview',
  id274: 'overview',
  id275: 'whatHappens',
  id276: 'whatHappens',
  id277: 'love',
  id278: 'love',
  id279: 'marriage',
  id280: 'marriage',
  id281: 'family',
  id282: 'family',
  id283: 'work',
  id284: 'work',
  id285: 'money',
  id286: 'money',
  id287: 'relationship',
  id288: 'relationship',
  id289: 'flowOfFortune',
  id290: 'flowOfFortune',
  id291: 'adviceForFirstHalf',
  id292: 'adviceForFirstHalf',
  id293: 'luckyDayCalendar',
  id294: 'luckyDayCalendar',
  id295: 'affinity',
  id296: 'affinity'
}

const setIds = {
  id297: 'flowOfFortuneSet',
  id298: 'flowOfFortuneSet',
  id299: 'loveSet',
  id300: 'loveSet',
  id301: 'relationshipSet',
  id302: 'relationshipSet',
  id303: 'allSet',
  id304: 'allSet'
}

function getItemColor(id) {
  if(id < 297){
    for (let key in itemIds) {
      if (key === `id${id}`) {
        return [color[itemIds[key]]]
      }
    }
  } else {
    return getSetItemColors(id)
  }
  return null
}

function getSetItemColors(id) {
  for (let key in setIds) {
    if (key === `id${id}`) {
      const rtn = []
      for (let item of set[setIds[key]]) {
        rtn.push(color[item])
      }
      return rtn
    }
  }
  return null
}

export default {
  color: color,
  set: set,
  itemIds: itemIds,
  setIds: setIds,
  getItemColor: getItemColor,
  getSetItemColors: getSetItemColors
}



// WEBPACK FOOTER //
// ./resources/assets/js/utvStore/components/YearLuck/y2020/constants/colors.js